import API from 'services/api';

export const deleteCalculationStatement = (statementId: string) => {
  return API.delete(`/api/accommodation/calculations/statements/${statementId}`);
};
